import { instance } from "../api/axiosInstance";
const axios = instance;

export const createTerminal = (params) => {
    return axios.post(`/terminals`, params);
}

export const fetchTerminalsList = (params) => {
    const userId = window.localStorage.getItem("userId");
    return axios.get(`/terminals/${userId}`,{params});
}

export const fetchTerminalsListForAdmin = (params) => {
    return axios.get(`/terminals`, {params});
}

export const editTerminalById = (terminalId, params) => {
    console.log(terminalId, params, 18)
    return axios.put(`/terminals/${terminalId}`, params);
}

export const fetchTerminalConfigs = (terminalId) => {
    return axios.get(`/terminals/${terminalId}/config`);
}

export const fetchHeidiTerminalConfigs = (terminalId) => {
    return axios.get(`/terminals/${terminalId}/config`);
}

export const createServices = (params, UserId) => {
    return axios.post(`/terminalsServices`, params);
}

export const getServices = (terminalId) => {
    return axios.get(`/terminalsServices/${terminalId}`);
}

export const getServicesHeidi = () => {
    return axios.get(`/services/types`);
}

export const addServiceImage = (serviceId, params) => {
    return axios.post(`/terminalsServices/${serviceId}/image`, params);
}

export const createNewCategory = (params) => {
    return axios.post(`/categories/`, params)
}

export const createNewCategoryByCityId = (cityId, params) => {
    return axios.post(`/categories/${cityId}`, params)
}

export const getAllQRCodes = (terminalId) => {
    // if (!id) {
        return axios.get(`qrcodes?terminalId=${terminalId}`);
    // }
    // return axios.get(`qrcodes?userId=${id}`);
}

export const createQRCodeGenerator = (params) => {
    return axios.post(`/qrcodes`, params)
}

export const uploadQRImage = (id, params) => {
    return axios.post(`qrcodes/${id}/image`, params)
}

export const createTerminalAds = (params) => {
    return axios.post(`/terminalsAds`, params)
}

export const uploadTerminalImage = (id, params, config = {}) => {
    return axios.post(`/terminalsAds/${id}/image`, params, config)
}

export const getAllAds = (terminalId) => {
    return axios.get(`terminalsAds/?terminalId=${terminalId}`);
}

export const submitTerminalConfigs = (terminalId, params) => {
    return axios.put(`terminals/${terminalId}/config`, params)
}

export const submitTerminalConfigsImages = (terminalId, params) => {
    return axios.post(`/terminals/${terminalId}/image`, params)
}

export const fetcTerminalData = (terminalId) => {
    return axios.get(`terminals/${terminalId}/public`)
}

export const updateServiceById = (serviceId, params) => {
    console.log("services: ", serviceId, params)
    return axios.put(`terminalsServices/${serviceId}`, params)
}

export const updateCategoryById = (categoryId, params) => {
    return axios.put(`categories/`, params)
}

export const updateScraperCategoryById = (cityId, params) => {
    return axios.put(`terminalcategoryscraper/${cityId}`, params)
}

export const updateCategoryByCityId = (cityId, params) => {
    return axios.put(`categories/${cityId}`, params)
}

export const getTerminalCategoryScraper = (cityId) => {
    return axios.get(`terminalcategoryscraper/${cityId}`);
}

export const updateService = (id, params) => {
    console.log("req data2 : ", params)
    return axios.patch(`services`, params)
}

export const getServiceById = (id) => {
    return axios.get(`services/${id}`)
}

export const deleteAppDashService = (id) => {
    return axios.delete(`services/${id}`)
}

export const getCategoryById = (id) => {
    return axios.get(`categories/${id}`)
}

export const deleteTerminal = (id) => {
    return axios.delete(`terminals/${id}`)
}

export const updateTerminalAd = (id, params) => {
    return axios.put(`terminalsAds/${id}`, params);
}

export const deleteTemplateAdsPoster = (id) => {
    return axios.delete(`terminalsAds/${id}`)
}
export const terminalServicesTypes = (id) => {
    return axios.get('/terminalsServices/types')
}